import { isDefined, isEqual, isNotDefined, type Workflow, type WorkflowHistoryItem } from '@terros/common'

export type IndexedHistoryItem = WorkflowHistoryItem & {
  index: number
}

/** Entries written by one account update share a user and location, and are spaced 1ms apart */
export const isSameHistoryBatch = (prev: WorkflowHistoryItem, item: WorkflowHistoryItem): boolean =>
  item.timestamp - prev.timestamp === 1 && item.userId === prev.userId && isEqual(item.latlng, prev.latlng)

type GroupHistoryBatchesProps = {
  timeline: WorkflowHistoryItem[]
  workflow: Workflow
}

/** Read backwards from each action, admitting only its configured pre-actions and checkpoints. */
export const groupHistoryBatches = ({ timeline, workflow }: GroupHistoryBatchesProps): IndexedHistoryItem[][] =>
  timeline.reduceRight<IndexedHistoryItem[][]>((batches, item, index) => {
    const batch = batches.at(0)
    const next = batch?.at(0)
    const action = workflow.getAction(batch?.at(-1)?.actionId)
    const isPreAction = action?.data.hooks?.pre?.some((hook) => hook.actionId === item.actionId) ?? false
    const canJoin = isNotDefined(item.actionId) || isPreAction
    if (isDefined(batch) && isDefined(next) && canJoin && isSameHistoryBatch(item, next)) {
      batch.unshift({ ...item, index })
      return batches
    }
    batches.unshift([{ ...item, index }])
    return batches
  }, [])
